<br />
<img alt="emit" class="system-logo" src="assets/images/logos/logo.png" />
<br />
<div class="forgot-password-container clearfix">
    @if (!checkEmail) {
        <form (ngSubmit)="onSubmit()" [formGroup]="forgotPasswordForm">
            <h2>Forgot Password</h2>
            <div class="row">
                <pcg-control-group class="col-sm-12" label="Email">
                    <input pcgControlRef formControlName="email" type="text" class="form-control email" />
                </pcg-control-group>
            </div>
            <button type="submit" class="btn btn-default btn-lg">Send Email</button>
        </form>
    }
    @if (checkEmail) {
        <div>
            <h2>Forgot Password Confirmation</h2>
            <p>
                Your email was submitted successfully.
                <br /><br />
                If you do not receive an email from us shortly, please verify that you entered the correct email.
                <br /><br />
                If you continue to have issues, contact us at
                <a href="mailto:Covid.Therapeutics@flhealth.gov">Covid.Therapeutics&#64;flhealth.gov</a>
            </p>
        </div>
    }
    <a class="float-right" routerLink="/login">Back to Login</a>
</div>
